import type { FC, PropsWithChildren } from "react";

import AdTag from "@/src/common/AdTag";
import { Breadcrumb, type IBreadcrumbItem } from "@/src/common/Breadcrumb";
import { browserStatics } from "@/src/shared/BrowserStatic";
import * as stylex from "@stylexjs/stylex";

export type IPageLayout = {
    layoutAdUnitPath?: string;
    slugTarget?: string;
    breadcrumbs?: IBreadcrumbItem[];
    isNewGrid?: boolean;
    adTagStyleX?: stylex.StyleXStyles;
};

const PageLayout: FC<PropsWithChildren<IPageLayout>> = ({
    children,
    layoutAdUnitPath,
    slugTarget,
    breadcrumbs,
    isNewGrid = false,
    adTagStyleX,
}) => (
    <>
        {browserStatics.shouldUserSeeAds && (layoutAdUnitPath || slugTarget) && (
            <AdTag
                optId="div-gpt-ad-1612271517787-1"
                layoutAdUnitPath={layoutAdUnitPath || ""}
                slugTarget={slugTarget.substring(0, 39) || ""}
                styleX={[styles.spacing, adTagStyleX]}
            />
        )}
        {!browserStatics.isMobileApp && breadcrumbs && (
            <Breadcrumb isNewGrid={isNewGrid} list={breadcrumbs} />
        )}
        {children}
    </>
);

const styles = stylex.create({
    spacing: {
        paddingBottom: 5,
        paddingTop: 5,
    },
});

export default PageLayout;
